import React, { useEffect, useState } from 'react';
import './DemoPreview.css';

const DemoPreview: React.FC = () => {
  const [isDark, setIsDark] = useState(false);

  // Detectar tema baseado apenas no data-theme selecionado
  useEffect(() => {
    const checkTheme = () => {
      const htmlElement = document.documentElement;
      const dataTheme = htmlElement.getAttribute('data-theme');

      // Usar apenas o tema selecionado (data-theme)
      const isDarkMode = dataTheme === 'dark';

      if (isDarkMode !== isDark) {
        setIsDark(isDarkMode); // Troca instantânea sem transição
      }


    };

    checkTheme();

    // Observar mudanças no data-theme
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    return () => {
      observer.disconnect();
    };
  }, [isDark]);

  const getImageSrc = () => (isDark ? '/crafteer-dashboard-dark.png' : '/crafteer-dashboard.png');

  return (
    <section className="demo-preview">
      <div className="demo-container">
        <img
          src={getImageSrc()}
          alt="Demonstração do Crafteer - Interface de gestão de campanhas"
          className="demo-image"
        />
      </div>
    </section>
  );
};

export default DemoPreview;
